// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d4a2c68e5381d9df3a243b337d20c8edeb05c2ef/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};